import { Room, TwilioError } from 'twilio-video';
import { useEffect } from 'react';

import { Callback } from '../../../types';
import { ROOM_COMPLETED_ERROR } from '../../../constants';

export default function useHandleRoomDisconnectionErrors(room: Room, onError: Callback) {
  useEffect(() => {
    const onDisconnected = (room: Room, error: TwilioError) => {
      // Don't show error dialog for expected "room completed" disconnection
      if (error && error.code !== ROOM_COMPLETED_ERROR) {
        // The dialog hides some codes from the user; keep every code in the console.
        console.log(`Room disconnected with error ${error.code}: ${error.message}`);
        onError(error);
      }
    };

    room.on('disconnected', onDisconnected);
    return () => {
      room.off('disconnected', onDisconnected);
    };
  }, [room, onError]);
}
